import React from 'react';
import { TableCell, TableRow, withStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

type Tprops = {
  layer: number;
  addNewItem: any;
  index?: number;
  thirdIndex?: number;
  fourthIndex?: number;
};

export const AddUnderLayerItemButtom: React.FC<Tprops> = (props: Tprops) => {
  const { layer, addNewItem, index, thirdIndex, fourthIndex } = props;

  return (
    <>
      <TableRow>
        <StyledTableCell
          align='center'
          style={{ width: 130, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 70, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 300, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 300, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{
            height: 50,
            width: 360,
            cursor: 'pointer'
          }}
          colSpan={3}
          onClick={() => {
            addNewItem(layer, index, thirdIndex, fourthIndex);
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <AddIcon />
            <span style={{ color: '#000000', fontSize: 16, marginLeft: 10 }}>
              明細を作成する
            </span>
          </div>
        </StyledTableCell>
        <StyledTableCell
          align='right'
          style={{ width: 120, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>
        <StyledTableCell
          align='right'
          style={{ width: 80, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 80, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 300, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>

        <StyledTableCell
          align='center'
          style={{ width: 100, backgroundColor: '#FFFFFF', height: 50 }}
        ></StyledTableCell>
      </TableRow>
    </>
  );
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: '1px #CCCCCC solid'
  },
  body: {
    backgroundColor: '#FFFFFF',
    height: 50
  }
}))(TableCell);
